import * as React from 'react'
import Link from 'next/link'

import { colors, media } from '../utils/style'
import { useTranslations } from 'next-intl'
import css from 'styled-jsx/css'

const { className: linkClassName, styles: linkStyles } = css.resolve`
  a {
    margin-left: 38px;
    color: ${colors.dashboardFooterText};
  }
`

export default function DashboardFooter() {
  const t = useTranslations()
  const [year] = React.useState(new Date().getFullYear())
  return (
    <div className="root">
      <div className="container">
        <span>
          {t('dashboardFooter.copyright', { year })}
        </span>

        <Link href="https://shipper.kz/privacy" className={linkClassName}>
          {t('dashboardFooter.nav.privacy')}
        </Link>
        <Link href="https://shipper.kz/agreement" className={linkClassName}>
          {t('dashboardFooter.nav.agreement')}
        </Link>
        <a
          href="https://shipper.statuspage.io/"
          target="_blank"
          rel="noopener noreferrer"
          className={linkClassName}
        >
          {t('dashboardFooter.nav.status')}
        </a>
      </div>

      {linkStyles}

      <style jsx>{`
        .root {
          display: none;
          padding: 67px 0 24px;
          font-size: 16px;
          line-height: 24px;

          color: ${colors.dashboardFooterText};
        }

        .container {
          display: flex;
          justify-content: flex-end;
        }

        span {
          margin-right: auto;
        }

        @media (min-width: ${media.desktop}px) {
          .root {
            display: block;
          }
        }
      `}</style>
    </div>
  )
}
